import React, { useMemo } from 'react';
import { InputGroup, InputLeftElement, Input, InputRightElement, IconButton } from '@chakra-ui/react';
import { SearchIcon, CloseIcon } from '@chakra-ui/icons';

export default function SearchInput({ value, onChange, placeholder = 'Search…', onClear, ...props }) {
  const showClear = useMemo(() => Boolean(value && value.length > 0), [value]);
  return (
    <InputGroup maxW={{ base: '100%', md: '260px' }}>
      <InputLeftElement pointerEvents="none">
        <SearchIcon color="gray.400" />
      </InputLeftElement>
      <Input
        value={value}
        onChange={e => onChange?.(e.target.value)}
        placeholder={placeholder}
        variant="filled"
        borderRadius="full"
        {...props}
      />
      <InputRightElement>
        {showClear && (
          <IconButton aria-label="Clear search" icon={<CloseIcon boxSize={2.5} />} size="sm" variant="ghost" onClick={onClear} />
        )}
      </InputRightElement>
    </InputGroup>
  );
}


